// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-96bc83ac] .el-input-number .el-input__inner{text-align:left!important}.cont-list[data-v-96bc83ac]{justify-content:normal}.cont-list .prompt[data-v-96bc83ac]{color:#ffcd00;font-size:14px;margin-left:10px;margin-top:3px}.packNumBox[data-v-96bc83ac] .el-form-item__content{display:flex!important}", ""]);
// Exports
module.exports = exports;
